import { User } from '../types';

export function isValidUser(value: unknown): value is User {
  const user = value as User;

  return Boolean(
    user &&
      typeof user.id === 'string' &&
      user.metadata &&
      typeof user.metadata.nickname === 'string' &&
      (user.metadata.vote === undefined ||
        typeof user.metadata.vote === 'string' ||
        typeof user.metadata.vote === 'number') &&
      (user.metadata.hasVoted === undefined ||
        typeof user.metadata.hasVoted === 'boolean') &&
      user.metadata.mod &&
      typeof user.metadata.mod.enabled === 'boolean'
  );
}

export function sanitizeUsers(users: unknown): User[] {
  if (!Array.isArray(users)) {
    return [];
  }

  return users.filter(isValidUser);
}
